module.exports = __webpack_public_path__ + "static/img/行驶.a0afda3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/挖掘机/行驶.png
// module id = oNZ3
// module chunks = 76